import { __assign, __rest } from "tslib";
import React, { useContext } from "react";
import classNames from "classnames";
import { RegionFlag } from "./RegionFlag";
import { useConfig } from "../_util/config-context";
import { noop } from "../_util/noop";
export var RegionOptionContext = React.createContext({});
export var RegionOption = React.forwardRef(function RegionOption(props, ref) {
    var classPrefix = useConfig().classPrefix;
    var inject = useContext(RegionOptionContext).inject;
    if (inject) {
        props = inject(props); // eslint-disable-line no-param-reassign
    }
    var children = props.children, dot = props.dot, num = props.num, selected = props.selected, disabled = props.disabled, onClick = props.onClick, value = props.value, flag = props.flag, country = props.country, restProps = __rest(props, ["children", "dot", "num", "selected", "disabled", "onClick", "value", "flag", "country"]);
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-region__item", {
            "is-selected": selected,
            "is-disabled": disabled,
        }), onClick: disabled ? noop : onClick }, restProps),
        React.createElement(RegionFlag, null),
        React.createElement("span", { className: classPrefix + "-region__name" },
            children,
            !!num && React.createElement("span", { className: classPrefix + "-region__num" }, num),
            dot && React.createElement("i", { className: classPrefix + "-region__new" }))));
});
RegionOption.displayName = "RegionOption";
//# sourceMappingURL=RegionOption.js.map